import "../assets/js/nav-pills.js";
import "../assets/scss/argon-dashboard.scss";
import Dialog from "@/helpers/dialog";
import MaterialNumberFormatter from "@/helpers/materialNumberFormatter";

// Custom SST Component
import BasePagination from "../components/BasePagination.vue";
import SmartcatAttachment from "../components/SmartcatAttachment.vue";
import UploadMultFilesWithPrimeVue from "../components/UploadMultFilesWithPrimeVue.vue";
import DisplayFilesGalleria from "../components/DisplayFilesGalleria.vue"
import UserForm from "../views/materialCatalogRequest/UserForm.vue"
import McrFooter from "../views/materialCatalogRequest/McrFooter.vue"
import McrItemFormDialog from "../components/McrItemFormDialog.vue"

// Primevue Component
import Tabs from "primevue/tabs";
import TabList from "primevue/tablist";
import Tab from "primevue/tab";
import TabPanels from "primevue/tabpanels";
import TabPanel from "primevue/tabpanel";
import AutoComplete from "primevue/autocomplete";
import Dropdown from "primevue/dropdown";
import DataTable from "primevue/datatable";
import TreeTable from "primevue/treetable";
import MultiSelect from "primevue/multiselect";
import Column from "primevue/column";
import Select from "primevue/select";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import ButtonPrime from "primevue/button";
import ButtonSplitPrime from "primevue/splitbutton";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import DialogPrime from "primevue/dialog";
import Skeleton from "primevue/skeleton";
import Badge from "primevue/badge";
import OverlayBadge from 'primevue/overlaybadge';
import Textarea from "primevue/textarea";
import Checkbox from 'primevue/checkbox';
import ToggleSwitch from 'primevue/toggleswitch';
import Password from 'primevue/password';
import Tooltip from 'primevue/tooltip';
import ToastPrime from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ColorPicker from 'primevue/colorpicker';
import Breadcrumb from 'primevue/breadcrumb';
import FileUpload from 'primevue/fileupload';
import Card from 'primevue/card';
import Calendar from 'primevue/calendar';
import Sidebar from 'primevue/sidebar';
import Galleria from 'primevue/galleria';
import Image from 'primevue/image';
import ProgressBar from 'primevue/progressbar';
import SelectButton from 'primevue/selectbutton';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

export default {
  install(app) {
    app.mixin({ methods: Dialog });
    app.mixin({ methods: MaterialNumberFormatter });

    // Register the component globally
    app.component("Tab", Tab);
    app.component("Tabs", Tabs);
    app.component("TabList", TabList);
    app.component("TabPanels", TabPanels);
    app.component("TabPanel", TabPanel);
    app.component("Dropdown", Dropdown);
    app.component("AutoComplete", AutoComplete);
    app.component("MultiSelect", MultiSelect);
    app.component("TreeTable", TreeTable);
    app.component("DataTable", DataTable);
    app.component("Column", Column);
    app.component("SelectPrime", Select);
    app.component("InputText", InputText);
    app.component("InputNumber", InputNumber);
    app.component("ButtonPrime", ButtonPrime);
    app.component("ButtonSplitPrime", ButtonSplitPrime);
    app.component("IconField", IconField);
    app.component("InputIcon", InputIcon);
    app.component("DialogPrime", DialogPrime);
    app.component("Skeleton", Skeleton);
    app.component("Badge", Badge);
    app.component("OverlayBadge", OverlayBadge);
    app.component("PrimeTextarea", Textarea);
    app.component("Checkbox", Checkbox);
    app.component("ToggleSwitch", ToggleSwitch);
    app.component("Password", Password);
    app.component("ToastPrime", ToastPrime);
    app.component("ColorPicker", ColorPicker);
    app.component("PrimeBreadcrumb", Breadcrumb);
    app.component("PrimeFileUpload", FileUpload);
    app.component("Card", Card);
    app.component("Calendar", Calendar);
    app.component("Sidebar", Sidebar);
    app.component("Galleria", Galleria);
    app.component("PrimeImage", Image);
    app.component("ProgressBar", ProgressBar);
    app.component("SelectButton", SelectButton);
    app.component("InputGroup", InputGroup);
    app.component("InputGroupAddon", InputGroupAddon);

    app.component("BasePagination", BasePagination);
    app.component("SmartcatAttachmentComp", SmartcatAttachment);
    app.component("UploadMultFilesWithPrimeVue", UploadMultFilesWithPrimeVue);
    app.component("DisplayFilesGalleria", DisplayFilesGalleria);
    app.component("UserForm", UserForm);
    app.component("McrFooter", McrFooter)
    app.component("McrItemFormDialog", McrItemFormDialog)

    app.directive("tooltip", Tooltip);

    app.use(ToastService)

    app.config.globalProperties.$toastNotifPrime = (severity, summary, detail) => {
      app.config.globalProperties.$toast.add({
        severity,
        summary,
        detail,
        life: 3000,
      });
    };
  },
};
